import ReservationDetail from './ReservationDetail'

export default ReservationDetail
